import { render, staticRenderFns } from "./ArticleLicenceTable.vue?vue&type=template&id=3cc7db3c&"
import script from "./ArticleLicenceTable.vue?vue&type=script&lang=ts&"
export * from "./ArticleLicenceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports